import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgElasticSearch = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-elastic-search';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M12.62 3.266a9 9 0 0 0-4.939 1.808c-.542.411-1.191 1.078-1.853 1.906l-.64.8 6.351.01 6.352.01 1.144-.665c.63-.366 1.153-.672 1.163-.681.026-.024-.436-.487-.898-.902-1.686-1.514-4.278-2.401-6.68-2.286m1.68 1.588a8.8 8.8 0 0 1 2.42.763c.39.194.96.53.96.566a.4.4 0 0 1-.118.076c-.104.054-.655.061-4.54.061-2.783 0-4.422-.014-4.422-.038 0-.07.733-.525 1.26-.783a7.2 7.2 0 0 1 2.34-.697c.409-.05 1.659-.019 2.1.052M4.408 10.33c-.218 1.242-.205 2.236.045 3.59l.048.26 5.339.012c3.684.008 5.476-.002 5.779-.032 1.042-.105 1.664-.61 1.88-1.527.071-.299.079-.864.017-1.161-.153-.734-.778-1.365-1.556-1.573-.188-.05-1.038-.058-5.843-.059H4.494zm11.351 1.091c.213.125.292.296.29.622-.002.339-.089.515-.291.585-.104.036-1.352.048-5.043.05l-4.906.002-.024-.09c-.031-.117-.031-1.063 0-1.181l.025-.09 4.905.01c4.852.011 4.907.012 5.044.092M5.225 16.25c.099.167 1.158 1.458 1.43 1.742a8.6 8.6 0 0 0 2.52 1.849 8.72 8.72 0 0 0 5.699.72c1.491-.309 2.815-.963 4.007-1.981.329-.281 1.399-1.39 1.399-1.449 0-.018-.553-.235-1.23-.482l-1.23-.449h-6.312c-5.039 0-6.307.01-6.283.05m12.25 1.545c-.514.403-1.362.839-2.1 1.082a6.5 6.5 0 0 1-2.022.352c-1.316.043-2.338-.167-3.473-.713-.429-.207-1.28-.724-1.28-.778 0-.01 2.018-.018 4.485-.018 4.387 0 4.484.002 4.39.075"
    })
  }));
});
export default SvgElasticSearch;